import "./EmailIntegrations.scss"

import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import * as appActions from "../../../redux/actions"
// eslint-disable-next-line import/no-cycle
import { useGlobalTranslation } from "../../../utils/hook"
import LangText from "../../atoms/LangText"
import EmailIntegration from "../EmailIntegration"

const EmailIntegrations = ({ accountID, userID }) => {
  const { tt } = useGlobalTranslation()
  return (
    <div className="email-integrations-wrapper">
      <div className="email-integrations-row">
        <div className="text">
          <div className="large">
            <LangText langKey="email.integrations.provider.label" />
          </div>
          <div className="small-description">
            <LangText langKey="email.integrations.provider.msg" />
          </div>
        </div>
        <div className="intergation_cards">
          <EmailIntegration type="gmail" title="Gmail" accountID={accountID} userID={userID} />
          <EmailIntegration
            type="outlook"
            title="Outlook"
            accountID={accountID}
            userID={userID}
            noRightMargin
          />
        </div>
      </div>
      <div className="email-integrations-row">
        <div className="text">
          <div className="large">
            <LangText langKey="email.integrations.connection-template.label" />
          </div>
          <div className="small-description">
            <LangText langKey="email.integrations.connection-template.msg" />
          </div>
        </div>
        <div className="intergation_cards">
          <EmailIntegration
            type="custom-gmail"
            title={tt("custom-gmail")}
            accountID={accountID}
            userID={userID}
          />
          <EmailIntegration
            type="custom-outlook"
            title={tt("custom-outlook")}
            accountID={accountID}
            userID={userID}
          />
          <EmailIntegration
            type="smtp"
            title={tt("custom-smtp-server")}
            accountID={accountID}
            userID={userID}
            noRightMargin
          />
        </div>
      </div>
    </div>
  )
}

// EmailIntegrations.propTypes = {
//   accountID: PropTypes.number.isRequired,
//   userID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
// }

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(appActions, dispatch),
})

export default connect(null, mapDispatchToProps)(React.memo(EmailIntegrations))
